/* eslint-disable */
export const isArray = (input) => {
  if (typeof input === 'object') {
    if (Array.isArray(input)) {
      return true;
    }
  }
  return false;
};
